/**
 * WaitlistGuard Component
 * 
 * UPDATE 2024-12: Waitlist removed - this component now just passes through.
 * Keeping the component to avoid breaking imports, but it no longer blocks anything.
 * 
 * Usage limits are now handled by the credit system:
 * - Anonymous: 3 free try-ons
 * - Free users: 10/month  
 * - Pro subscribers: Unlimited
 */

import { ReactNode } from 'react';

interface WaitlistGuardProps {
  children: ReactNode;
}

export function WaitlistGuard({ children }: WaitlistGuardProps) {
  // Waitlist removed - everyone has access
  // Credit system handles usage limits
  return <>{children}</>;
}
